import { Validators } from '@angular/forms';
import {
  MixedSchema,
  initVersionedSchema,
  type RawInlineNodes,
} from '@principle-theorem/editor';
import { TypedFormControl, TypedFormGroup } from '@principle-theorem/ng-shared';
import { ConditionLogic } from '@principle-theorem/principle-core';
import {
  ConditionLogicConfigurationCollection,
  TaskPriority,
  TemplateScope,
  type IPractice,
  type IStaffer,
  type ITeam,
} from '@principle-theorem/principle-core/interfaces';
import {
  isDocRef,
  type DocumentReference,
  type INamedDocument,
} from '@principle-theorem/shared';
import { type Moment } from 'moment-timezone';
import { TimingFormGroup } from '../timing.formgroup';
import { type IGeneratedTaskFormData } from './generated-task-edit.component';

export class GeneratedTaskEditForm extends TypedFormGroup<
  Omit<IGeneratedTaskFormData, 'deleted' | 'isActive' | 'treatmentRefs'>
> {
  constructor() {
    super({
      title: new TypedFormControl<RawInlineNodes>([], Validators.required),
      assignee: new TypedFormControl<INamedDocument<IStaffer | ITeam>>(
        undefined,
        Validators.required
      ),
      timing: new TimingFormGroup(),
      priority: new TypedFormControl<TaskPriority>(TaskPriority.Low),
      comment: new TypedFormControl<MixedSchema>(initVersionedSchema()),
      isForTeam: new TypedFormControl<boolean>(false),
      triggerDate: new TypedFormControl<Moment | undefined>({
        value: undefined,
        disabled: true,
      }),
      triggerTime: new TypedFormControl<string | undefined>({
        value: undefined,
        disabled: true,
      }),
      scope: new TypedFormControl<TemplateScope>(),
      practiceRef: new TypedFormControl<
        DocumentReference<IPractice> | undefined
      >({
        value: undefined,
        disabled: true,
      }).withGuard(isDocRef),
      requiredConditions:
        new TypedFormControl<ConditionLogicConfigurationCollection>(
          ConditionLogic.collection([
            ConditionLogic.and([ConditionLogic.always()]),
          ])
        ),
    });
  }

  enableTriggerControls(): void {
    this.controls.triggerDate.enable();
    this.controls.triggerTime.enable();
  }
}
